

// import { useEffect, useMemo, useState, useCallback } from 'react';
// import axios from "../../api/axiosAuth";

// import { useAuth } from '../../context/AuthContext';
// import '../../style/PerfilRectorBoletines.css';

// /* =========================================
//    🌐 API BASE
// ========================================= */
// // const API = 'http://localhost:5001';

// const API = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";

// /* =========================================
//    🏫 PERFIL RECTOR — BOLETINES + PUESTOS SINAI
// ========================================= */
// export default function PerfilRectorBoletines() {
//   const { token, user } = useAuth();

//   /* =========================
//      🧠 ESTADOS
//   ========================= */
//   const [modo, setModo] = useState('SEDE'); // SEDE | TENANT
//   const [sedeId, setSedeId] = useState('');
//   const [grado, setGrado] = useState('');
//   const [grupo, setGrupo] = useState('');
//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);
//   const [periodoActivo, setPeriodoActivo] = useState(null);
//   const [sedes, setSedes] = useState([]);
//   const [estudiantes, setEstudiantes] = useState([]);
//   const [ranking, setRanking] = useState([]);
//   const [loadingZip, setLoadingZip] = useState(false);
//   const [loadingPuestos, setLoadingPuestos] = useState(false);
//   const [error, setError] = useState('');

// const [profesoresPendientes, setProfesoresPendientes] = useState([]);
// const [loadingProfesores, setLoadingProfesores] = useState(false);

// const cargarProfesoresPendientes = async () => {
//   if (!periodoActivo?.id || !sedeId) return;

//   try {
//     setLoadingProfesores(true);
//     setError('');

//     const res = await axiosAuth.get('/api/boletin/profesores-notas-pendientes', {
//       params: {
//         periodo_id: periodoActivo.id,
//         sede_id: Number(sedeId)
//       }
//     });

//     // Guardamos resultados, asegurando que sea un array
//     setProfesoresPendientes(Array.isArray(res.data) ? res.data : []);

//   } catch (err) {
//     console.error('❌ Error cargando profesores pendientes:', err);
//     setError(
//       err.response?.data?.message ||
//       'Error cargando reporte de profesores con notas pendientes'
//     );
//     setProfesoresPendientes([]);
//   } finally {
//     setLoadingProfesores(false);
//   }
// };





//   /* =========================================
//      🔐 AXIOS AUTH
//   ========================================= */
//   const axiosAuth = useMemo(() => {
//     const instance = axios.create({
//       baseURL: API,
//       withCredentials: true
//     });

//     instance.interceptors.request.use(config => {
//       if (token) config.headers.Authorization = `Bearer ${token}`;
//       return config;
//     });

//     return instance;
//   }, [token]);

//   /* =========================================
//      🔄 CARGA INICIAL
//   ========================================= */
//   useEffect(() => {
//     if (!token) {
//       setError('No hay sesión activa. Inicie sesión nuevamente.');
//       return;
//     }
//     cargarSedes();
//     cargarPeriodoActivo();
//   }, [token]);

//   /* =========================================
//      🏫 CARGAR SEDES
//   ========================================= */
//   const cargarSedes = useCallback(async () => {
//     try {
//       const res = await axiosAuth.get('/api/sedes');
//       setSedes(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       console.error('❌ Error cargando sedes:', err);
//       setError('No se pudieron cargar las sedes');
//     }
//   }, [axiosAuth]);

//   /* =========================================
//      📅 CARGAR PERIODO ACTIVO
//   ========================================= */
//   const cargarPeriodoActivo = useCallback(async () => {
//     try {
//       const res = await axiosAuth.get('/api/cronograma/periodos/activo');
//       let data = res.data;
//       if (data?.periodoActivo) data = data.periodoActivo;
//       if (Array.isArray(data)) data = data[0];
//       if (!data?.id) {
//         setPeriodoActivo(null);
//         setError('No hay periodo activo configurado');
//         return;
//       }
//       setPeriodoActivo({
//         id: data.id,
//         nombre: data.nombre,
//         numero: data.numero
//       });
//     } catch (err) {
//       console.error('❌ Error periodo activo:', err);
//       setError('Error consultando periodo activo');
//     }
//   }, [axiosAuth]);

//   /* =========================================
//      🎓 CARGAR GRADOS
//   ========================================= */
//   const cargarGrados = async (sedeSeleccionada = null) => {
//     try {
//       setError('');
//       const params = { modo };
//       if (modo === 'SEDE') {
//         if (!sedeSeleccionada) {
//           setError('Debe seleccionar una sede para cargar los grados');
//           return;
//         }
//         params.sede_id = Number(sedeSeleccionada);
//       }
//       const res = await axiosAuth.get('/api/boletin/grados', { params });
//       setGrados(Array.isArray(res.data) ? res.data : []);
//       setGrado('');
//       setGrupos([]);
//       setGrupo('');
//       setEstudiantes([]);
//       setRanking([]);
//     } catch (err) {
//       console.error('❌ Error cargando grados:', err);
//       setError('Error consultando los grados');
//     }
//   };

//   /* =========================================
//      🧩 CARGAR GRUPOS
//   ========================================= */
//   const cargarGrupos = async gradoSeleccionado => {
//     if (!gradoSeleccionado) return;
//     try {
//       setError('');
//       const params = { modo, grado: gradoSeleccionado };
//       if (modo === 'SEDE') params.sede_id = Number(sedeId);
//       const res = await axiosAuth.get('/api/boletin/grupos', { params });
//       setGrupos(Array.isArray(res.data) ? res.data : []);
//       setGrupo('');
//       setEstudiantes([]);
//       setRanking([]);
//     } catch (err) {
//       console.error('❌ Error cargando grupos:', err);
//       setError('Error consultando los grupos');
//     }
//   };

//   /* =========================================
//      👩‍🎓 CARGAR ESTUDIANTES + ACUMULADO + DESEMPEÑO
//   ========================================= */


// const cargarEstudiantes = async (gradoSel, grupoSel) => {
//   if (!gradoSel || !grupoSel || !periodoActivo?.id) return;

//   try {
//     setError('');
//     setLoadingZip(true);

//     const body = {
//       modo,
//       grado: gradoSel,
//       grupo: grupoSel,
//       periodo_id: periodoActivo.id,
//       sede_id: modo === 'SEDE' ? Number(sedeId) : null
//     };

//     // 1️⃣ Traer estudiantes
//     const res = await axiosAuth.post('/api/boletin/estudiantes', body);
//     const data = Array.isArray(res.data?.estudiantes)
//       ? res.data.estudiantes
//       : [];

//     const estudiantesProcesados = await Promise.all(
//       data.map(async (est) => {
//         const materiasProcesadas = await Promise.all(
//           (est.materias || []).map(async (m) => {
//             try {
//               const resAcum = await axiosAuth.post(
//                 '/api/boletin/acumulado-anual',
//                 {
//                   estudiante_id: est.id,
//                   grado: est.grado,
//                   grupo: est.grupo,
//                   materia_id: m.materia_id,
//                   periodo_id: periodoActivo.id
//                 }
//               );

//               // const acumulado = Number(resAcum.data?.acumulado ?? 0);
//               // const materiaPerdida = Boolean(resAcum.data?.materia_perdida);

//               // // ✅ CAMBIO AQUÍ
//               // const estadoMateria =
//               //   resAcum.data?.desempeno || 'N/A';

//               const acumulado = Number(resAcum.data?.acumulado ?? 0);
// const materiaPerdida = Boolean(resAcum.data?.materia_perdida);

// const estadoMateria =
//   resAcum.data?.estado_materia ?? 'N/A';


//               const items = await obtenerItemsConNotas(
//                 est.id,
//                 m.materia_id,
//                 est.grado,
//                 est.grupo
//               );

//               return {
//                 ...m,
//                 nota_periodo: Number(m.nota || 0),
//                 nota_acumulado: acumulado,
//                 desempeno: estadoMateria,
//                 promovido: !materiaPerdida,
//                 detalle_periodos: resAcum.data?.detalle || [],
//                 items
//               };
//             } catch (err) {
//               console.error(
//                 '❌ Error procesando materia:',
//                 err.response?.data || err.message || err
//               );

//               return {
//                 ...m,
//                 nota_periodo: Number(m.nota || 0),
//                 nota_acumulado: Number(m.nota || 0),
//                 desempeno: 'N/A',
//                 promovido: false,
//                 detalle_periodos: [],
//                 items: []
//               };
//             }
//           })
//         );

//         let suma = 0;
//         let materiasPerdidas = 0;

//         materiasProcesadas.forEach((mat) => {
//           const nota = Number(mat.nota_acumulado || 0);
//           suma += nota;

//           if (!mat.promovido) {
//             materiasPerdidas++;
//           }
//         });

//         const promedioGeneral = materiasProcesadas.length
//           ? Number((suma / materiasProcesadas.length).toFixed(2))
//           : 0;

//         let estadoFinal = "PROMOVIDO";

//         if (materiasPerdidas > 2) {
//           estadoFinal = "REPROBADO";
//         } else if (materiasPerdidas > 0) {
//           estadoFinal = "RECUPERACION";
//         }

//         return {
//           ...est,
//           materias: materiasProcesadas,
//           promedio_general: promedioGeneral,
//           materias_perdidas: materiasPerdidas,
//           estado_final: estadoFinal
//         };
//       })
//     );

//     setEstudiantes(estudiantesProcesados);
//     setRanking([]);

//   } catch (err) {
//     console.error(
//       '❌ Error cargando estudiantes:',
//       err.response?.data || err.message || err
//     );
//     setError('Error consultando estudiantes');
//   } finally {
//     setLoadingZip(false);
//   }
// };




//   const obtenerItemsConNotas = async (estudianteId, materiaId, grado, grupo) => {
//   try {
//     const res = await axiosAuth.post('/api/boletin/materia-items', {
//       estudiante_id: estudianteId,
//       materia_id: materiaId,
//       periodo_id: periodoActivo?.id,   // 🔥 ESTO FALTABA
//       grado,
//       grupo
//     });

//     return res.data?.items || [];
//   } catch (error) {
//     console.error('Error obteniendo items:', error);
//     return [];
//   }
// };

//   /* =========================================
//      🏆 CALCULAR PUESTOS SINAI
//   ========================================= */
//   const cargarPuestos = async () => {
//     if (!grado || !grupo || !periodoActivo?.id || !estudiantes.length) return;

//     try {
//       setLoadingPuestos(true);
//       setError('');

//       const body = { estudiantes };
//       const res = await axiosAuth.post('/api/boletin/puestos', body);
//       if (Array.isArray(res.data?.estudiantes)) setRanking(res.data.estudiantes);
//     } catch (err) {
//       console.error('❌ Error calculando puestos:', err);
//       setError('Error calculando puestos. Revise las notas de los estudiantes.');
//     } finally {
//       setLoadingPuestos(false);
//     }
//   };

//   useEffect(() => {
//     if (estudiantes.length > 0 && grado && grupo && periodoActivo?.id) cargarPuestos();
//   }, [estudiantes]);

//   /* =========================================
//      📦 GENERAR ZIP BOLETINES
//   ========================================= */
// const generar = async () => {
//   if (!grado || !grupo) {
//     return setError("Debe seleccionar grado y grupo");
//   }

//   if (modo === "SEDE" && !sedeId) {
//     return setError("Debe seleccionar una sede");
//   }

//   if (!periodoActivo?.id) {
//     return setError("No hay periodo activo");
//   }

//   try {
//     setLoadingZip(true);
//     setError("");

//     const body = {
//       grado,
//       grupo,
//       periodo_id: periodoActivo.id,
//       sede_id: modo === "SEDE" ? Number(sedeId) : null,
//     };

//     console.log("📤 Generando boletines con body:", body);

//     // 🔥 ENDPOINT CORRECTO
//     const response = await axiosAuth.post(
//       "/api/boletin/generar-masivo",
//       body,
//       { timeout: 120000 }
//     );

//     console.log("✅ Respuesta backend:", response.data);

//     if (!response.data?.total) {
//       throw new Error("No se generaron boletines");
//     }

//     alert(`✅ ${response.data.total} boletines generados correctamente`);

//   } catch (err) {
//     console.error("❌ Error generando boletines:", err);

//     if (err.response) {
//       console.error("📄 Respuesta del backend:", err.response.data);
//     }

//     if (err.response?.status === 403) {
//       setError("No tienes permisos para generar boletines");
//     } else if (err.response?.status === 401) {
//       setError("Sesión expirada. Inicie sesión nuevamente.");
//     } else {
//       setError(
//         err.response?.data?.message ||
//         err.message ||
//         "Error generando boletines"
//       );
//     }
//   } finally {
//     setLoadingZip(false);
//   }
// };

// /* =========================================
//    📥 DESCARGAR ZIP DE BOLETINES
// ========================================= */
// const descargarZip = async () => {

//   /* =============================
//      VALIDACIONES
//   ============================== */

//   if (!grado || !grupo) {
//     return setError("Debe seleccionar grado y grupo");
//   }

//   if (modo === "SEDE" && !sedeId) {
//     return setError("Debe seleccionar una sede");
//   }

//   if (!periodoActivo?.id) {
//     return setError("No hay periodo activo");
//   }

//   try {

//     setLoadingZip(true);
//     setError("");

//     /* =============================
//        BODY DEL REQUEST
//     ============================== */

//     const body = {
//       modo,
//       grado,
//       grupo,
//       periodo_id: periodoActivo.id,
//       sede_id: modo === "SEDE" ? Number(sedeId) : null
//     };

//     console.log("📥 Descargando ZIP boletines:", body);

//     /* =============================
//        REQUEST AL BACKEND
//     ============================== */

//     const res = await axiosAuth.post(
//       "/api/boletin/descargar-zip",
//       body,
//       {
//         responseType: "blob",
//         timeout: 120000
//       }
//     );

//     /* =============================
//        DESCARGA DEL ARCHIVO
//     ============================== */

//     const blob = new Blob([res.data], { type: "application/zip" });

//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;

//     link.setAttribute(
//       "download",
//       `Boletines_${grado}_${grupo}_Periodo_${periodoActivo.numero}.zip`
//     );

//     document.body.appendChild(link);
//     link.click();

//     link.remove();
//     window.URL.revokeObjectURL(url);

//     console.log("✅ ZIP descargado correctamente");

//   } catch (err) {

//     console.error("❌ Error descargando ZIP:", err);

//     /* =============================
//        LEER ERROR DEL BACKEND (BLOB)
//     ============================== */

//     if (err.response?.data instanceof Blob) {

//       try {

//         const text = await err.response.data.text();
//         console.error("📄 Error backend (texto):", text);

//         const json = JSON.parse(text);
//         setError(json.message || "Error descargando boletines");

//       } catch (e) {

//         console.error("📄 Error backend sin JSON:", e);
//         setError("Error descargando boletines");

//       }

//     } else {

//       console.error("📄 Backend respondió:", err.response?.data);

//       setError(
//         err.response?.data?.message ||
//         err.message ||
//         "Error descargando boletines"
//       );

//     }

//   } finally {

//     setLoadingZip(false);

//   }

// };







//   /* =========================================
//      🖥️ UI
//   ========================================= */



// return (
//   <div className="panel">
//     <h2>📦 Generación Masiva de Boletines — Rector</h2>

//     {error && <div className="error-box">⚠️ {error}</div>}

//     <div className="card">
//       <p>
//         <strong>Institución:</strong>{" "}
//         {user?.institucion_nombre ||
//           user?.tenant_nombre ||
//           `Institución ${user?.tenant_id || "—"}`}
//       </p>
//       <p>
//         <strong>Rector:</strong> {user?.nombre || "—"} {user?.apellido || ""}
//       </p>
//       <p>
//         <strong>Periodo Activo:</strong>{" "}
//         {periodoActivo
//           ? `${periodoActivo.nombre} (Periodo ${periodoActivo.numero})`
//           : "No hay periodo activo"}
//       </p>
//     </div>

//     {/* FORM SELECCIÓN */}
//     <div className="form">
//       <select
//         value={modo}
//         onChange={(e) => {
//           const nuevo = e.target.value;
//           setModo(nuevo);
//           setSedeId("");
//           setGrados([]);
//           setGrupos([]);
//           setEstudiantes([]);
//           setRanking([]);
//           setGrado("");
//           setGrupo("");
//         }}
//       >
//         <option value="SEDE">Generar por sede</option>
//         <option value="TENANT">Generar todo el tenant</option>
//       </select>

//       {modo === "SEDE" && (
//         <select
//           value={sedeId}
//           onChange={(e) => {
//             const sede = e.target.value;
//             setSedeId(sede);
//             cargarGrados(sede);
//           }}
//         >
//           <option value="">Seleccione sede</option>
//           {sedes.map((s) => (
//             <option key={s.id} value={s.id}>
//               {s.nombre}
//             </option>
//           ))}
//         </select>
//       )}

//       {modo === "TENANT" && (
//         <button type="button" onClick={() => cargarGrados(null)}>
//           📚 Cargar grados del tenant
//         </button>
//       )}

//       <select
//         value={grado}
//         onChange={(e) => {
//           const g = e.target.value;
//           setGrado(g);
//           cargarGrupos(g);
//         }}
//       >
//         <option value="">Seleccione grado</option>
//         {grados.map((g) => (
//           <option key={g} value={g}>
//             {g}
//           </option>
//         ))}
//       </select>

//       <select
//         value={grupo}
//         onChange={(e) => {
//           const g = e.target.value;
//           setGrupo(g);
//           cargarEstudiantes(grado, g);
//         }}
//       >
//         <option value="">Seleccione grupo</option>
//         {grupos.map((g) => (
//           <option key={g} value={g}>
//             {g}
//           </option>
//         ))}
//       </select>

//       <button onClick={generar} disabled={loadingZip}>
//         {loadingZip ? "⏳ Generando ZIP..." : "📥 Generar Boletines"}
//       </button>

//       <button onClick={descargarZip} disabled={loadingZip}>
//   {loadingZip ? "⏳ Descargando..." : "⬇️ Descargar boletines PDF"}
// </button>


//       <button
//   onClick={async () => {
//     if (!grado || !grupo || !periodoActivo?.id) {
//       alert("Seleccione grado, grupo y período");
//       return;
//     }

//     try {
//       const res = await axios.post(
//         "/boletin/enviar-padre-masivo",
//         { grado, grupo, periodo_id: periodoActivo.id },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       alert(res.data.message);
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || "Error enviando boletines al módulo del padre");
//     }
//   }}
// >
//   📤 Enviar boletines al módulo del padre
// </button>

// <button
//   onClick={cargarProfesoresPendientes}
//   disabled={!sedeId || !periodoActivo?.id || loadingProfesores}
// >
//   {loadingProfesores ? '⏳ Cargando reporte...' : '📋 Ver profesores con notas pendientes'}
// </button>

// {/* Mensaje de error */}
// {error && (
//   <div className="card">
//     <p style={{ color: 'red' }}>{error}</p>
//   </div>
// )}

// {/* Profesores pendientes y completos */}
// {profesoresPendientes.length > 0 && (
//   <div className="card">
//     <h3>📋 Profesores y materias</h3>
//     <table className="ranking-table">
//       <thead>
//         <tr>
//           <th>Profesor</th>
//           <th>Materia</th>
//           <th>Total Estudiantes</th>
//           <th>Notas Publicadas</th>
//           <th>Estado</th>
//         </tr>
//       </thead>
//       <tbody>
//         {profesoresPendientes.map((p) => (
//           <tr key={`${p.profesor_id}-${p.materia_id || 'sin-asignacion'}`}>
//             <td>{p.profesor}</td>
//             <td>{p.materia || 'Sin asignaciones en esta sede'}</td>
//             <td>{p.total_estudiantes || 0}</td>
//             <td>{p.notas_publicadas || 0}</td>
//             <td>
//               {p.total_estudiantes === 0
//                 ? 'ℹ️ Sin asignaciones'
//                 : p.notas_publicadas < p.total_estudiantes
//                   ? '❌ Pendientes'
//                   : '✅ Completas'}
//             </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// )}

// {/* Mensaje si no hay profesores */}
// {profesoresPendientes.length === 0 && !loadingProfesores && (
//   <div className="card">
//     <p>No hay profesores registrados en este tenant o sede.</p>
//   </div>
// )}







//       {loadingPuestos && (
//         <span className="loading-text">
//           ⏳ Calculando puestos SINAI...
//         </span>
//       )}
//     </div>

//     {/* RANKING */}
//     {ranking.length > 0 && (
//       <div className="card">
//         <h3>🏆 Ranking Oficial — Puestos SINAI</h3>
//         <table className="ranking-table">
//           <thead>
//             <tr>
//               <th>Puesto</th>
//               <th>Estudiante</th>
//               <th>Promedio</th>
//               <th>Desempeño</th>
//               <th>Honor</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ranking.map((e) => (
//               <tr key={e.id}>
//                 <td>{e.puesto}</td>
//                 <td>{e.nombres} {e.apellidos}</td>
//                 <td>{e.promedio}</td>
//                 <td>{e.desempeno_final}</td>
//                 <td>{e.cuadro_honor ? "🏅 Cuadro de Honor" : ""}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     )}


//   {/* profesores faltantes */}
//     {loadingPuestos && (
//         <span className="loading-text">
//           ⏳ Calculando puestos SINAI...
//         </span>
//       )}
   
  

//     {/* ESTUDIANTES */}
//     {estudiantes.length > 0 && (
//       <div className="card boletin">
//         <h3 className="boletin-titulo">
//           Estudiantes cargados ({estudiantes.length})
//         </h3>

//         <ul className="lista-estudiantes">
//           {estudiantes.map((est) => (
//             <li key={est.id} className="estudiante-card">

//               {/* 🔥 ESTADO FINAL GLOBAL */}
//               <div className="estado-anual-box">
//                 <div className="estado-anual-titulo">
//                   Estado Académico Final
//                 </div>

//                 <div className={`estado-anual estado-${est.estado_final}`}>
//                   {est.estado_final === "PROMOVIDO" && "🟢 PROMOVIDO"}
//                   {est.estado_final === "RECUPERACION" && "🟡 RECUPERA"}
//                   {est.estado_final === "REPROBADO" && "🔴 PIERDE EL AÑO"}
//                 </div>

//                 <div className="estado-extra">
//                   Promedio General: {est.promedio_general ?? "-"} |
//                   Materias Perdidas: {est.materias_perdidas ?? 0}
//                 </div>
//               </div>

//               <div className="estudiante-header">
//                 <div className="estudiante-nombre">
//                   {est.nombres} {est.apellidos}
//                 </div>
//                 <div className="estudiante-info">
//                   {est.documento} · {est.grado}° {est.grupo}
//                 </div>
//               </div>

//               <ul className="lista-materias">
//                 {est.materias?.map((m) => (
//                   <li key={m.materia_id} className="materia-card">

//                     <div className="materia-header">
//                       <span className="materia-nombre">{m.materia}</span>
//                       <span className="materia-nota">
//                         {m.nota_acumulado ?? "-"}
//                       </span>
//                     </div>

//                     {/* ITEMS */}
//                     {Array.isArray(m.items) && m.items.length > 0 && (
//                       <div className="items-box">
//                         <div className="items-titulo">
//                           Ítems de calificación
//                         </div>
//                         <ul className="lista-items">
//                           {[...new Map(
//                             m.items.map((it) => [it.item_id, it])
//                           ).values()].map((item, index) => (
//                             <li
//                               key={`${item.item_id}-${index}`}
//                               className="item-fila"
//                             >
//                               <div className="item-linea">
//                                 <span className="item-nombre">
//                                   {item.nombre_item || "Item"}
//                                 </span>
//                                 <span className="item-nota">
//                                   {item.nota_final_item ?? "-"}
//                                 </span>
//                               </div>

//                               {item.logro && (
//                                 <div className="item-logro">
//                                   <strong>Logro:</strong> {item.logro.titulo}
//                                   {item.logro.descripcion && (
//                                     <div className="item-logro-desc">
//                                       {item.logro.descripcion}
//                                     </div>
//                                   )}
//                                 </div>
//                               )}
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     )}

//                     {/* PERIODOS */}
//                     {Array.isArray(m.detalle_periodos) &&
//                       m.detalle_periodos.length > 0 && (
//                         <div className="periodos-box">
//                           <div className="items-titulo">
//                             Detalle por periodos
//                           </div>

//                           <ul className="lista-periodos">
//                             {m.detalle_periodos.map((p, i) => (
//                               <li key={i} className="periodo-fila">
//                                 <span className="periodo-nombre">
//                                   {p.periodo}
//                                 </span>
//                                 <span className="periodo-dato">
//                                   Nota: {p.nota ?? "-"}
//                                 </span>
//                                 <span className="periodo-dato">
//                                   Peso: {p.peso ?? "-"}%
//                                 </span>
//                                 <span className="periodo-dato">
//                                   Aporte: {p.aporte ?? "-"}
//                                 </span>
//                               </li>
//                             ))}
//                           </ul>

//                           <div className="acumulado-info">
//                             <span>
//                               Acumulado anual: {m.nota_acumulado ?? "-"}
//                             </span>
//                             <span>
//                               Desempeño: {m.desempeno ?? "-"}
//                             </span>
//                           </div>
//                         </div>
//                       )}

//                   </li>
//                 ))}
//               </ul>

//             </li>
//           ))}
//         </ul>
//       </div>
//     )}
//   </div>
// );

// }


//
import { useEffect, useState } from 'react';
import axiosAuth from "../../api/axiosAuth";
import { useAuth } from '../../context/AuthContext';
import '../../style/PerfilRectorBoletines.css';
import LoaderBoletines from "../../components/LoaderBoletines";


export default function PerfilRectorBoletines() {

  const { token } = useAuth();

  const [modo, setModo] = useState('SEDE');
  const [sedeId, setSedeId] = useState('');
  const [grado, setGrado] = useState('');
  const [grupo, setGrupo] = useState('');

  const [grados, setGrados] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [sedes, setSedes] = useState([]);

  const [periodoActivo, setPeriodoActivo] = useState(null);

  const [estudiantes, setEstudiantes] = useState([]);
  const [ranking, setRanking] = useState([]);

  const [loadingZip, setLoadingZip] = useState(false);
  const [loadingPuestos, setLoadingPuestos] = useState(false);

  const [showLoader, setShowLoader] = useState(false);
const [loaderText, setLoaderText] = useState("Procesando...");

  const [error, setError] = useState('');

  const logError = (label, err) => {
    console.error(`❌ ${label}:`, err?.response?.data || err.message);
    setError(err?.response?.data?.message || label);
  };

  /* ================= INIT ================= */
  useEffect(() => {
    if (!token) return setError('No hay sesión activa');

    cargarSedes();
    cargarPeriodoActivo();
  }, [token]);

  /* ================= SEDES ================= */
  const cargarSedes = async () => {
    try {
      const res = await axiosAuth.get('/sedes');
      setSedes(res.data || []);
    } catch (err) {
      logError("Error sedes", err);
    }
  };

  /* ================= PERIODO ================= */
  const cargarPeriodoActivo = async () => {
    try {
      const res = await axiosAuth.get('/cronograma/periodos/activo');
      const p = res.data?.periodoActivo || res.data;

      if (!p?.id) return setError('No hay periodo activo');

      setPeriodoActivo(p);

    } catch (err) {
      logError("Error periodo activo", err);
    }
  };

  /* ================= GRADOS ================= */
  const cargarGrados = async (sede) => {
    try {
      const res = await axiosAuth.get('/boletin/grados', {
        params: { modo, sede_id: modo === 'SEDE' ? sede : null }
      });

      setGrados(res.data || []);

    } catch (err) {
      logError("Error grados", err);
    }
  };

  /* ================= GRUPOS ================= */
  const cargarGrupos = async (gradoSel) => {
    try {
      const res = await axiosAuth.get('/boletin/grupos', {
        params: {
          modo,
          grado: gradoSel,
          sede_id: modo === 'SEDE' ? sedeId : null
        }
      });

      setGrupos(res.data || []);

    } catch (err) {
      logError("Error grupos", err);
    }
  };

  /* ================= ESTUDIANTES ================= */
  // const cargarEstudiantes = async (gradoSel, grupoSel) => {

  //   if (!gradoSel || !grupoSel) return setError("Seleccione grado y grupo");
  //   if (modo === "SEDE" && !sedeId) return setError("Seleccione sede");
  //   if (!periodoActivo?.id) return setError("No hay periodo activo");

  //   try {
  //     setLoadingZip(true);
  //     setError("");

  //     const res = await axiosAuth.post('/boletin/estudiantes', {
  //       modo,
  //       grado: gradoSel,
  //       grupo: grupoSel,
  //       periodo_id: Number(periodoActivo.id),
  //       sede_id: modo === "SEDE" ? Number(sedeId) : null
  //     });

  //     setEstudiantes(res.data?.estudiantes || []);

  //   } catch (err) {
  //     logError("Error estudiantes", err);
  //   } finally {
  //     setLoadingZip(false);
  //   }
  // };

const cargarEstudiantes = async (gradoSel, grupoSel) => {
  let t1, t2, t3;

  if (!gradoSel || !grupoSel) {
    return setError("Seleccione grado y grupo");
  }

  if (modo === "SEDE" && !sedeId) {
    return setError("Seleccione sede");
  }

  if (!periodoActivo?.id) {
    return setError("No hay periodo activo");
  }

  try {
    setLoadingZip(true);
    setShowLoader(true);
    setError("");
    setLoaderText("Consultando estudiantes matriculados...");

    // 🔥 Etapas visuales mientras backend responde
    t1 = setTimeout(() => {
      setLoaderText("Verificando notas registradas...");
    }, 2000);

    t2 = setTimeout(() => {
      setLoaderText("Calculando promedios académicos...");
    }, 5000);

    t3 = setTimeout(() => {
      setLoaderText("Organizando listado final...");
    }, 8000);

    const payload = {
      modo,
      grado: gradoSel,
      grupo: grupoSel,
      periodo_id: Number(periodoActivo.id),
      sede_id: modo === "SEDE" ? Number(sedeId) : null
    };

    console.log("📘 Consultando estudiantes:", payload);

    const res = await axiosAuth.post(
      "/boletin/estudiantes",
      payload,
      {
        timeout: 0
      }
    );

    const estudiantesRecibidos = res.data?.estudiantes || [];

    setLoaderText("Finalizando consulta...");

    setEstudiantes(estudiantesRecibidos);

    console.log(`✅ Estudiantes cargados: ${estudiantesRecibidos.length}`);

  } catch (err) {
    console.error("❌ Error estudiantes:", err?.response?.data || err.message);

    logError("Error estudiantes", err);

    setEstudiantes([]);

  } finally {
    clearTimeout(t1);
    clearTimeout(t2);
    clearTimeout(t3);

    setLoadingZip(false);
    setShowLoader(false);
  }
};


  /* ================= PUESTOS ================= */
  const cargarPuestos = async () => {
    try {
      setLoadingPuestos(true);

      const res = await axiosAuth.post('/boletin/puestos', {
        estudiantes
      });

      setRanking(res.data?.estudiantes || []);

    } catch (err) {
      logError("Error puestos", err);
    } finally {
      setLoadingPuestos(false);
    }
  };

  useEffect(() => {
    if (estudiantes.length) cargarPuestos();
  }, [estudiantes]);

  /* ================= GENERAR ================= */
  const generar = async () => {
    try {
      setLoadingZip(true);

      const res = await axiosAuth.post('/boletin/generar-masivo', {
        grado,
        grupo,
        periodo_id: periodoActivo?.id,
        sede_id: modo === 'SEDE' ? sedeId : null
      });

      alert(`✅ ${res.data.total} boletines generados`);

    } catch (err) {
      logError("Error generando", err);
    } finally {
      setLoadingZip(false);
    }
  };

  /* ================= DESCARGAR ZIP ================= */
  // const descargarZip = async () => {
  //   try {
  //     setLoadingZip(true);

  //     const res = await axiosAuth.post(
  //       '/boletin/descargar-zip',
  //       {
  //         modo,
  //         grado,
  //         grupo,
  //         periodo_id: periodoActivo?.id,
  //         sede_id: modo === 'SEDE' ? sedeId : null
  //       },
  //       { responseType: 'blob' }
  //     );

  //     const blob = new Blob([res.data]);
  //     const url = URL.createObjectURL(blob);

  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = 'boletines.zip';
  //     a.click();

  //   } catch (err) {
  //     logError("Error descargando ZIP", err);
  //   } finally {
  //     setLoadingZip(false);
  //   }
  // };

  const descargarZip = async () => {
  let t1, t2, t3, t4;

  try {
    setLoadingZip(true);
    setShowLoader(true);
    setLoaderText("Consultando estudiantes matriculados...");

    // 🔥 etapas visuales automáticas mientras backend procesa
    t1 = setTimeout(() => {
      setLoaderText("Calculando puestos académicos...");
    }, 2500);

    t2 = setTimeout(() => {
      setLoaderText("Generando boletines PDF individuales...");
    }, 6500);

    t3 = setTimeout(() => {
      setLoaderText("Integrando observaciones y desempeño...");
    }, 11000);

    t4 = setTimeout(() => {
      setLoaderText("Comprimiendo archivos ZIP...");
    }, 16000);

    const payload = {
      modo,
      grado,
      grupo,
      periodo_id: Number(periodoActivo?.id),
      sede_id: modo === "SEDE" ? Number(sedeId) : null
    };

    console.log("📦 Solicitando ZIP masivo:", payload);

    const res = await axiosAuth.post(
      "/boletin/descargar-zip",
      payload,
      {
        responseType: "blob",
        timeout: 0 // 🔥 sin límite porque puede tardar bastante
      }
    );

    // 🔥 validar blob recibido
    if (!res.data || res.data.size === 0) {
      throw new Error("El servidor no retornó archivo ZIP");
    }

    setLoaderText("Finalizando descarga...");

    const blob = new Blob([res.data], {
      type: "application/zip"
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `Boletines_${grado}_${grupo}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    console.log("✅ ZIP descargado correctamente");

  } catch (err) {
    console.error("❌ Error descargando ZIP:", err?.response?.data || err.message);

    logError("Error descargando ZIP", err);

    setError(
      err?.response?.data?.message ||
      "No fue posible generar los boletines masivos"
    );

  } finally {
    clearTimeout(t1);
    clearTimeout(t2);
    clearTimeout(t3);
    clearTimeout(t4);

    setLoadingZip(false);
    setShowLoader(false);
  }
};

  /* ================= UI ================= */

  /* ================= UI ================= */
  /* ================= UI ================= */
return (
  <div className="panel">

<LoaderBoletines visible={showLoader} etapa={loaderText} />

    <h2>📦 Generación Masiva de Boletines</h2>

    {error && <div className="error-box">⚠️ {error}</div>}

    <div className="form">

      <select value={modo} onChange={e => setModo(e.target.value)}>
        <option value="SEDE">Por sede</option>
        <option value="TENANT">Todo</option>
      </select>

      {modo === "SEDE" && (
        <select value={sedeId} onChange={e => {
          setSedeId(e.target.value);
          cargarGrados(e.target.value);
        }}>
          <option value="">Seleccione sede</option>
          {sedes.map(s => (
            <option key={s.id} value={s.id}>{s.nombre}</option>
          ))}
        </select>
      )}

    <select value={grado} onChange={e => {
  const g = e.target.value;
  setGrado(g);
  cargarGrupos(g);
}}>

        <option value="">Grado</option>
        {grados.map(g => <option key={g}>{g}</option>)}
      </select>

      <select value={grupo} onChange={e => {
  const g = e.target.value;
  setGrupo(g);
  cargarEstudiantes(grado, g); // 🔥 le pasas el valor correcto
}}>

        <option value="">Grupo</option>
        {grupos.map(g => <option key={g}>{g}</option>)}
      </select>

      <button onClick={generar}>
        📥 Generar
      </button>

      <button onClick={descargarZip}>
        ⬇️ Descargar
      </button>

      {/* <button onClick={cargarProfesoresPendientes}>
        📋 Profesores pendientes
      </button> */}

    </div>

    {/* 🔄 LOADING PUESTOS */}
    {loadingPuestos && (
      <span className="loading-text">
        ⏳ Calculando puestos SINAI...
      </span>
    )}

    {/* 🏆 RANKING */}
    {ranking.length > 0 && (
      <div className="card">
        <h3>🏆 Ranking Oficial — Puestos SINAI</h3>

        <table className="ranking-table">
          <thead>
            <tr>
              <th>Puesto</th>
              <th>Estudiante</th>
              <th>Promedio</th>
              <th>Desempeño</th>
              <th>Honor</th>
            </tr>
          </thead>

          <tbody>
            {ranking.map((e) => (
              <tr key={e.id}>
                <td>{e.puesto}</td>
                <td>{e.nombres} {e.apellidos}</td>
                <td>{e.promedio}</td>
                <td>{e.desempeno_final}</td>
                <td>
                  {e.cuadro_honor ? "🏅 Cuadro de Honor" : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    {/* 👨‍🎓 ESTUDIANTES */}
    {estudiantes.length > 0 && (
      <div className="card boletin">

        <h3 className="boletin-titulo">
          Estudiantes cargados ({estudiantes.length})
        </h3>

        <ul className="lista-estudiantes">
          {estudiantes.map((est) => (
            <li key={est.id} className="estudiante-card">

              {/* 🔥 ESTADO FINAL */}
              <div className="estado-anual-box">
                <div className="estado-anual-titulo">
                  Estado Académico Final
                </div>

                <div className={`estado-anual estado-${est.estado_final}`}>
                  {est.estado_final === "PROMOVIDO" && "🟢 PROMOVIDO"}
                  {est.estado_final === "RECUPERACION" && "🟡 RECUPERA"}
                  {est.estado_final === "REPROBADO" && "🔴 PIERDE EL AÑO"}
                </div>

                <div className="estado-extra">
                  Promedio General: {est.promedio_general ?? "-"} |
                  Materias Perdidas: {est.materias_perdidas ?? 0}
                </div>
              </div>

              <div className="estudiante-header">
                <div className="estudiante-nombre">
                  {est.nombres} {est.apellidos}
                </div>
                <div className="estudiante-info">
                  {est.documento} · {est.grado}° {est.grupo}
                </div>
              </div>

              <ul className="lista-materias">
                {est.materias?.map((m) => (
                  <li key={m.materia_id} className="materia-card">

                    <div className="materia-header">
                      <span className="materia-nombre">{m.materia}</span>
                      <span className="materia-nota">
                        {m.nota_acumulado ?? "-"}
                      </span>
                    </div>

                    {/* ITEMS */}
                    {Array.isArray(m.items) && m.items.length > 0 && (
                      <div className="items-box">
                        <div className="items-titulo">
                          Ítems de calificación
                        </div>

                        <ul className="lista-items">
                          {[...new Map(
                            m.items.map((it) => [it.item_id, it])
                          ).values()].map((item, index) => (
                            <li key={`${item.item_id}-${index}`} className="item-fila">

                              <div className="item-linea">
                                <span className="item-nombre">
                                  {item.nombre_item || "Item"}
                                </span>
                                <span className="item-nota">
                                  {item.nota_final_item ?? "-"}
                                </span>
                              </div>

                              {item.logro && (
                                <div className="item-logro">
                                  <strong>Logro:</strong> {item.logro.titulo}

                                  {item.logro.descripcion && (
                                    <div className="item-logro-desc">
                                      {item.logro.descripcion}
                                    </div>
                                  )}
                                </div>
                              )}

                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* PERIODOS */}
                    {Array.isArray(m.detalle_periodos) &&
                      m.detalle_periodos.length > 0 && (
                        <div className="periodos-box">

                          <div className="items-titulo">
                            Detalle por periodos
                          </div>

                          <ul className="lista-periodos">
                            {m.detalle_periodos.map((p, i) => (
                              <li key={i} className="periodo-fila">
                                <span className="periodo-nombre">{p.periodo}</span>
                                <span className="periodo-dato">Nota: {p.nota ?? "-"}</span>
                                <span className="periodo-dato">Peso: {p.peso ?? "-"}%</span>
                                <span className="periodo-dato">Aporte: {p.aporte ?? "-"}</span>
                              </li>
                            ))}
                          </ul>

                          <div className="acumulado-info">
                            <span>Acumulado anual: {m.nota_acumulado ?? "-"}</span>
                            <span>Desempeño: {m.desempeno ?? "-"}</span>
                          </div>

                        </div>
                      )}

                  </li>
                ))}
              </ul>

            </li>
          ))}
        </ul>

      </div>
    )}

  </div>
);
}
